import { Euler } from "three";

export interface RailPartOptions {
  railWidth: number;
  railHeight: number;
  railDepth: number;

  edgeWidth: number;
  edgeHeight: number;
  edgeDepth: number;

  bottomHeight: number;
  bottomDepth: number;

  topHeight: number;
  topDepth: number;

  baseWidth: number;
  baseHeight: number;
  baseDepth: number;
  baseOffsetX: number;
  baseOffsetY: number;
  baseOffsetZ: number;
  baseRotation: Euler;

  railSpacing: number;
  railOffset: number;
  bottomOffset: number;
  edgeOffset: number;

  startOffset: number;
  endOffset: number;
  heightOffset: number;
  depthOffset: number;

  width: number;
  depth: number;
  height: number;
}

export const defaultRailPartOptions: RailPartOptions = {
  railWidth: 0.013,
  railHeight: 0.875,
  railDepth: 0.045,
  railSpacing: 0.1043,
  railOffset: 0.025,

  edgeWidth: 0.013,
  edgeHeight: 0.965,
  edgeDepth: 0.065,
  edgeOffset: 0.015,

  bottomHeight: 0.0229,
  bottomDepth: 0.055,
  bottomOffset: 0.08,

  topHeight: 0.03,
  topDepth: 0.08,

  baseWidth: 0.06,
  baseHeight: 0.015,
  baseDepth: 0.08,
  baseOffsetX: 0.0,
  baseOffsetY: 0.0,
  baseOffsetZ: 0.0,
  baseRotation: new Euler(0, 0, 0),

  startOffset: 0.08,
  endOffset: 0.08,
  heightOffset: 0.0,
  depthOffset: 0.04,

  width: 1.2,
  depth: 0.08,
  height: 1.01,
};
